import React from 'react';
import styled from 'styled-components';
import { CategoryEnum, CategoryType, PaperStatusName } from '../../store/paper-status/types.d';
import { useTranslation } from 'react-i18next';
import { getPaperStatusName as getTPaperStatusName } from '../../helpers/translations';

interface Props {
  name: PaperStatusName;
  category: CategoryType;
}

const PaperStatusLabel: React.FC<Props> = ({ name, category }) => {
  const { t, i18n } = useTranslation();

  let color;
  switch (category) {
    case CategoryEnum.In_Progress:
      color = '#b2e5fb';
      break;
    case CategoryEnum.Accepted:
      color = '#8bc34a';
      break;
    case CategoryEnum.Rejection:
      color = '#EF9A9A';
      break;
    default:
      color = '';
  }

  return (
    <StyledPaperStatus backgroundColor={color}>
      <span>{getTPaperStatusName(name, t)}</span>
    </StyledPaperStatus>
  );
};

const StyledPaperStatus = styled.div<{ backgroundColor: string }>`
  background-color: ${(props) => props.backgroundColor};
  border-radius: 0.25rem;
  max-width: 8.8rem;
  padding: 0.5rem;
  font-size: 12px;
`;

export default PaperStatusLabel;
